import apiClient from './api';

export interface Brand {
  id?: number;
  code: string;
  name: string;
  description?: string;
  image?: string | File;
  status?: string;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}

export interface BrandResponse {
  success: boolean;
  message: string;
  data: Brand | Brand[];
}

export const brandService = {
  // Get all brands
  async getBrands(): Promise<Brand[]> {
    try {
      const response = await apiClient.get('/brands');
      return response.data;
    } catch (error) {
      console.error('Error fetching brands:', error);
      throw error;
    }
  },

  // Get single brand by ID
  async getBrand(id: number): Promise<Brand> {
    try {
      const response = await apiClient.get(`/brands/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching brand ${id}:`, error);
      throw error;
    }
  },

  // Create new brand
  async createBrand(data: FormData): Promise<Brand> {
    try {
      const response = await apiClient.post('/brands', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating brand:', error);
      throw error;
    }
  },

  // Update existing brand
  async updateBrand(id: number, data: FormData): Promise<Brand> {
    try {
      if (!data.has('_method')) {
        data.append('_method', 'PUT');
      }
      const response = await apiClient.post(`/brands/${id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating brand ${id}:`, error);
      throw error;
    }
  },

  // Delete brand
  async deleteBrand(id: number): Promise<void> {
    try {
      await apiClient.delete(`/brands/${id}`);
    } catch (error) {
      console.error(`Error deleting brand ${id}:`, error);
      throw error;
    }
  },

  // Search brands
  async searchBrands(query: string): Promise<Brand[]> {
    try {
      const response = await apiClient.get(`/brands/search?q=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Error searching brands:', error);
      throw error;
    }
  },
};

export default brandService;